import { PopStoreExtendedSubscriptionLevel } from '@ps/models';

import { kOrderedExtendedSubscriptionLevels } from '../../subscription/configuration/functions/subscription-display';

/**
 * Whether upgrading from `current` to `target` is disallowed: same tier, or a
 * downgrade (target at or below current in the ordered enum). Returns `false`
 * when either is missing (nothing to gate against). Ported from PopshopRN's
 * `isDisabledForExtendedSubscriptionLevelUpgrade`.
 */
export function isDisabledForExtendedSubscriptionLevelUpgrade(
  current: PopStoreExtendedSubscriptionLevel | undefined,
  target: PopStoreExtendedSubscriptionLevel | undefined,
): boolean {
  if (!current || !target) return false;
  if (current === target) return true;

  const currentIndex = kOrderedExtendedSubscriptionLevels.indexOf(current);
  const targetIndex = kOrderedExtendedSubscriptionLevels.indexOf(target);
  if (currentIndex === -1 || targetIndex === -1) return true;

  return targetIndex <= currentIndex;
}
